import { formatDateFromDateAndTime } from "utils";

const getSeriesData = ({ data, type = "bar", smooth = false, ...props }) => {
  const colors = ["#D50AB5", "#50B3A2", "#F39C12", "#3498DB", "#9B59B6"];

  const { lineStyle = {}, itemStyle = {}, label = {} } = props;

  const obj = (e, i) => {
    const params = {
      name: `Series${i}`,
      type,
      smooth,
      lineStyle: {
        ...lineStyle,
        normal: {
          color: colors[i % colors.length],
          width: 1,
          ...lineStyle?.normal,
        },
      },
      data: e,
      barWidth: "30%",
      barCategoryGap: "30%",
      
      position: "top",
      itemStyle: {
        ...itemStyle,
        // Apply gradient color
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 1,
          colorStops: [
            { offset: 0, color: "#FE4066" }, // Color at the start (0%)
            { offset: 1, color: "#FFDFE5" }, // Color at the end (100%)
          ],
          global: false,
          ...itemStyle?.color,
        },
      },
      label: {
        // show: true,
        position: "right", // Position label at the end of the bar
        // formatter: "{c}", // Display the value of the bar
        ...label,
        textStyle: {
          color: "#333",
          fontSize: 12,
          ...label?.textStyle,
        },
      },
      ...props,
    };

    return params;
  };
  console.log("data is",data)

  const modifiedYdata = data?.map((e, i) => obj(e, i)) || [];

  return modifiedYdata;
};

export const PieOptions = (data) => {
  const options = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      left: "right",
      top: "middle",
      align: "left",
    },
    series: [
      {
        name: "Access From",
        type: "pie",
        radius: ["40%", "70%"],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: "center",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 40,
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };

  return options;
};

const commonAxisLabelStyle = {
  textStyle: {
    color: "#333",
    fontSize: 12,
  },
};
const getParams = ({ XAxisData = [], params }) => {
  console.log("xdsdfa",XAxisData)
  const xParams = {
    type: "category",
    data: XAxisData,
    axisLabel: {
      formatter: (value) => value?.split(",")?.[0] || "",
      ...commonAxisLabelStyle,
    },
    axisLine: {
      lineStyle: {
        color: '#888', // Customize the axis line color
        width: 2,      // Customize the axis line width
      },
    },
    axisTick: {
      show: false,      // Show or hide ticks
      // alignWithLabel: true,
      lineStyle: {
        color: '#555', // Customize tick color
      },
    },
    ...params?.x
  
  };

  const yParams = {
    type: "value",
    
    axisLabel: {
      formatter: (value) => `${value}`,
      ...commonAxisLabelStyle,
    },
    ...params?.y
  };

  return { xParams, yParams };
};

export const FirstGraph = (data,smooth) => {
  const XAxisData = [
    "Jan 26, 2024",
    "Jan 28, 2024",
    "Jan 30, 2024",
    "Jul 2, 2024",
    "Jul 4, 2024",
    "Jul 6, 2024",
    "Jul 8, 2024",
    "Jul 10, 2024",
    "Jul 12, 2024",
    "Jul 14, 2024",
    "Jul 16, 2024",
    "Jul 18, 2024",
  ];

 
  const { xParams, yParams } = getParams({ XAxisData, });

  const SeriesData = getSeriesData({
    data: data,
    type: "line",
    symbol:"none",
    smooth,
    label:{
      show:false
    }
    
  });

  return { xAxis: xParams, yAxis: yParams, series: SeriesData };
};

// export const pieGraph = (data) => {
//   const AxisData = ["Organic Search", "Paid Search", "Social Media", "Direct"];

//   const data_ = data?.map((e, i) => {
//     return { name: AxisData[i], value: e };
//   });

//   const pieDAta = PieOptions(data_);


//   return pieDAta;
// };

export const pieGraph = ({ xAxisData, yAxisData, params, series }) => {
  // const AxisData = ["Organic Search", "Paid Search", "Social Media", "Direct"];

  const data_ = xAxisData?.map((e, i) => {
    return { name: xAxisData[i], value: yAxisData[i] };
  });

  console.log("data is",data_)

  const pieDAta = PieOptions(data_);


  return pieDAta;
};

export const horiztonalBarGraph = ({ xAxisData, yAxisData, params, series }) => {
  console.log("horiztonalBarGraphdata is",xAxisData, yAxisData,series)
  // const XAxisData = [
  //   "Google pay",
  //   "Apple pay",
  //   "Card payment",
  //   "Wire transfer",
  //   "Paypal",
  // ];

  const { xParams, yParams } = getParams({ XAxisData:xAxisData, type: "bar", });

  const SeriesData = getSeriesData({
    data: yAxisData,
    type: "bar",
    label:{
      position:"right"

    }
  });

  return { xAxis: yParams, yAxis: xParams, series: SeriesData };
};

export const OnlineStoreColumn = [
  {
    name: "Ticket type",
    cell: (row) => (
      <div>
        {/* Custom label for each row */}
        <strong>{`${row.header}`}</strong>
        <div>{row.value}</div>
      </div>
    ),
    sortable: true,
  },
  {
    name: "",
    selector: (row) => row.sales,
    sortable: true,
  },
  {
    name: "",
    selector: (row) => row.revenue,
    sortable: true,
  },
];

export const OnlineStoreData = [
  {
    id: 1,
    header: "Added to cart",
    value: "114 sessions",
    sales: "4.34",
    revenue: "3%",
  },
  {
    id: 1,
    header: "Added to cart",
    value: "114 sessions",
    sales: "4.34",
    revenue: "3%",
  },
  {
    id: 1,
    header: "Added to cart",
    value: "114 sessions",
    sales: "4.34",
    revenue: "3%",
  },
];

export const TicketTypeColumn = [
  {
    name: "Ticket type",
    cell: (row) => (
      <div>
        {/* Custom label for each row */}
        <strong>{`${row.header}`}</strong>
        <div>{row.value}</div>
      </div>
    ),
    sortable: true,
  },
  {
    name: "",
    selector: (row) => row.sales,
    sortable: true,
  },
  {
    name: "",
    selector: (row) => row.revenue,
    sortable: true,
  },
];

export const TicketTypeData = [
  {
    id: 1,
    header: "Added to cart",
    value: "114 sessions",
    sales: "4.34",
    revenue: "3%",
  },
  {
    id: 1,
    header: "Added to cart",
    value: "114 sessions",
    sales: "4.34",
    revenue: "3%",
  },
  {
    id: 1,
    header: "Added to cart",
    value: "114 sessions", 
    sales: "4.34",
    revenue: "3%",
  },
];


// export const FirstGraph = (data,smooth) => {
//   const XAxisData = [
//     "Jan 26, 2024",
//     "Jan 28, 2024",
//     "Jan 30, 2024",
//     "Jul 2, 2024",
//     "Jul 4, 2024",
//     "Jul 6, 2024",
//     "Jul 8, 2024",
//     "Jul 10, 2024",
//     "Jul 12, 2024",
//     "Jul 14, 2024",
//     "Jul 16, 2024",
//     "Jul 18, 2024",
//   ];

 
//   const { xParams, yParams } = getParams({ XAxisData, });

//   const SeriesData = getSeriesData({
//     data: data,
//     type: "line",
//     symbol:"none",
//     smooth,
//     label:{
//       show:false
//     }
    
//   });

//   return { xAxis: xParams, yAxis: yParams, series: SeriesData };
// };




  // export const GetOrderVolume = ({data,xValue, yValue}) => {

  //   let XAxisData = data?.map((e)=>e?.[xValue])

  //   if(xValue=="date"){
  //     XAxisData = data?.map((e)=>formatDateFromDateAndTime(e?.[xValue]))
  //   }

  //   const yAxisData = [data?.map((e)=>e[yValue])]

  //   console.log("ordermer kkkktircs",XAxisData,yAxisData, data)

  
  //   const { xParams, yParams } = getParams({ XAxisData, });

  //   const SeriesData = getSeriesData({
  //     data: yAxisData,
  //     type: "line",
  //     symbol:"none",
  //     smooth:true,
  //     label:{
  //       show:false
  //     }
  //   });

  //   return { xAxis: xParams, yAxis: yParams, series: SeriesData };
  // };

  export const GetOrderVolume = ({ xAxisData, yAxisData, params, series }) => {
    const { xParams, yParams } = getParams({ XAxisData: xAxisData,params });
  
    console.log("Asdfasdf", xAxisData, yAxisData)
    const SeriesData = getSeriesData({
      data: yAxisData, // An array of datasets (e.g., new and returning users)
      type: "line",
      smooth: true,
      symbol: "none",
      label: {
        show: false,
      },
      ...series
    });
  
    return { xAxis: xParams, yAxis: yParams, series: SeriesData };
  };